import { extendTheme } from '@chakra-ui/react';

import Button from './components/button';
import Checkbox from './components/checkbox';
import CloseButton from './components/closeButton';
import Divider from './components/divider';
import Drawer from './components/drawer';
import Input from './components/input';
import Menu from './components/menu';
import Modal from './components/modal';
import Popover from './components/popover';
import Radio from './components/radio';
import StatusBadge from './components/statusBadge';
import Switch from './components/switch';
import Toast from './components/toast';
import Tooltip from './components/tooltip';
import colors from './foundation/colors';
import fonts from './foundation/fonts';
import fontSizes from './foundation/fontSizes';
import fontWeights from './foundation/fontWeights';
import { layerStyles } from './foundation/layerStyles';
import radii from './foundation/radii';
import shadows from './foundation/shadows';
import textStyles from './foundation/textStyles';
import styles from './styles';

const overrides = {
  colors,
  components: {
    Button,
    Drawer,
    Input,
    Popover,
    Switch,
    Checkbox,
    Radio,
    Menu,
    Tooltip,
    CloseButton,
    Divider,
    Modal,
    Toast,
    StatusBadge
  },
  fonts,
  fontSizes,
  fontWeights,
  layerStyles,
  radii,
  shadows,
  styles,
  textStyles
};

const pinsTheme = extendTheme(overrides);

export default pinsTheme;
